import React from 'react';

// Local Components
import Separator from '../FormFields/Separator';
import Searchbar from '../FormFields/Searchbar';
import SortBySearchChip from '../Chips/SortBySearchChip';
import VenueCard from '../Cards/VenueCard';

// Buttons
import { FilterBtn } from '../Buttons/Buttons';

// Typography
import { H4, H3 } from '../../themes/typography';

// FontAwesome Icons
import { FilterIcon, SortByIcon } from '../../icons/FontAwesomeIcon';

// CSS Styles
import '../../styles/components/FoodAndDrinks.css';

export default function BusinessAndProfessional() {
    return (
        <React.Fragment>
            <div className="business-venues-discovery-container">
                <div className="main-business-listing-container">
                    <div className="business-title">
                        <H3 color="#f8a21e" fontWeight={600}>
                            Business & Professional Venues in Surat
                        </H3>
                        <Separator />
                    </div>

                    <div className="business-filter-area-container">
                        <H4 color="#f8a21e" fontWeight={600}>
                            Explore Venues For Your Next Outing
                        </H4>

                        {/* Searchbar */}
                        <div className="business-searchbar">
                            <Searchbar />
                        </div>

                        {/* Quick Filter Section */}
                        <div className="quick-business-filter-container">
                            <div className="quick-business-filter-chips-area">
                                <div className="business-filter-container">
                                    <FilterBtn
                                        name="Filters"
                                        icon={
                                            <FilterIcon
                                                style={{
                                                    color: '#F8A21E',
                                                    fontSize: '0.875rem'
                                                }}
                                            />
                                        }
                                    />
                                </div>

                                {/* For Future Activation */}
                                {/* <div className="separator-of-filter"></div>

                                <div className="business-result-active-chips">
                                    <SortBySearchChip />
                                </div> */}
                            </div>
                            {/* For Future Activation */}
                            {/* <div className="quick-sort-by-area">
                                <div className="business-sort-by-container">
                                    <FilterBtn
                                        name="Sort By"
                                        icon={
                                            <SortByIcon
                                                style={{
                                                    color: '#F8A21E',
                                                    fontSize: '0.875rem'
                                                }}
                                            />
                                        }
                                    />
                                </div>
                            </div> */}
                        </div>

                        {/* Separator */}
                        <Separator />
                    </div>

                    {/* Venue Listing Container */}
                    <div className="business-venues-listing-container">
                        <div className="business-venues-flex-listing-container">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((_, index) => (
                                <VenueCard key={`venue-${index}`} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
